export const BLE_CONNECTION_NEW = 'new';
